import { render } from "./KariirekinSetting.vue?vue&type=template&id=e8265b4a&ts=true"
import script from "./KariirekinSetting.vue?vue&type=script&lang=ts"
export * from "./KariirekinSetting.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__